<template>
  <component
    :is="as"
    :class="['tab', 'secondary-font', { active }]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    as: {
      type: String,
      default: 'button',
    },
    active: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.tab {
  @include transition(background-color, border-bottom-color);

  border: none;
  background-color: transparent;
  cursor: pointer;
  font-weight: 500;
  font-size: 18px;
  padding: 0 $gp * 1.5;
  height: 45px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-bottom: solid 3px var(--theme-active);
  text-transform: uppercase;
  text-decoration: none !important;
  color: var(--theme-color);
  -webkit-appearance: none;

  &:hover {
    background-color: var(--theme-highlight);
  }

  &.router-link-exact-active,
  &.nuxt-link-exact-active,
  &.active {
    border-bottom-color: $color-green-1;
  }
}
</style>
